
import Slider from 'react-slick';   
import  './EnterpriseTabSlide.css';
const PrevArrow = (props) => (
    <button {...props} className="slick-prev">
      <img src="/img/rentshield/claims_arrow_left.svg" alt="Previous" width="48" height="48" />
    </button>
  );
  
  const NextArrow = (props) => (
    <button {...props} className="slick-next">
      <img src="/img/rentshield/claims_arrow_right.svg" alt="Next" width="48" height="48" />
    </button>
  );


const EnterpriseTabSlide = ()=>{

// START cards
  // const cards = [
  //   { 
  //     id: 1, 
  //     image: '/img/Pricing/flow_square_2.svg',
  //     heading: 'Scalable & Developer-Ready', 
  //     text: 'Access to advanced APIs, automation, and scalable fleet solutions designed to integrate seamlessly.' 
  //   },
  //   { 
  //     id: 2, 
  //     image: '/img/Pricing/layers_2.svg',
  //     heading: 'Powerful API Integrations', 
  //     text: 'Connect Rentid to your internal systems to automate bookings, fleet management, and payments.' 
  //   },
  //   { 
  //     id: 3, 
  //     image: '/img/Pricing/rentid_2.svg',
  //     heading: 'Custom Workflows & Automation', 
  //     text: 'Streamline operations with dynamic pricing, risk assessment, and real-time reporting.' 
  //   },
  //   { 
  //     id: 4, 
  //     image: '/img/Pricing/analytics_up_2.svg',
  //     heading: 'Advanced Fleet Analytics', 
  //     text: 'Track vehicle performance, rental trends, and financial insights to optimize business decisions.' 
  //   },
  //   { 
  //     id: 5, 
  //     image: '/img/Pricing/tools_2.svg',
  //     heading: 'Dedicated Developer & Partner Support', 
  //     text: 'Access to documentation, sandbox environments, and technical assistance.' 
  //   },
  //  ];
// END cards


// START slick
const settings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  margin: 30,
  autoplay: true,
  autoplaySpeed: 2000,

  // autoplaySpeed: 0,  // No delay between scrolls
  // speed: 4000,  // Smooth continuous movement
  // cssEase: 'linear',

  loop: true,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  centerPadding: '30px',
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        infinite: true,
        margin: 30,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        margin: 20,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Correcting the key to 'slidesToShow'
        centerPadding: "30px",
      },
    },
  ],
};
// END slick

    return(
        <>
            {/* START enterpriseSlideMain */}
            <section className="enterpriseSlideMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="enterpriseSlideHead">
                                <h2>Let’s Partner & Build Together</h2>
                            </div>
                        </div>
                    </div>
                  </div>
                  
                  <div className='row justify-content-center'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <Slider {...settings}>  
                            <div className="item">
                              <div className="enterpriseSlideDetail">
                                <img className="img-fluid" src="/img/Pricing/flow_square_2.svg" alt="Scalable & Developer-Ready" />
                                <h3>Scalable &<br/> Developer-Ready</h3>
                                <p>Access to advanced APIs, automation,<br/> and scalable fleet solutions<br/> designed to integrate seamlessly.</p>
                              </div>
                            </div>
                          
                            <div className="item">
                              <div className="enterpriseSlideDetail">
                                <img className="img-fluid" src="/img/Pricing/layers_2.svg" alt="Powerful API Integrations" />
                                <h3>Powerful API<br/> Integrations</h3>
                                <p>Connect Rentid to your internal<br/> systems to automate bookings,<br/> fleet management, and payments.</p>
                              </div>
                            </div>  

                            <div className="item">
                              <div className="enterpriseSlideDetail">
                                <img className="img-fluid" src="/img/Pricing/rentid_2.svg" alt="Custom Workflows & Automation" />
                                <h3>Custom Workflows<br/> & Automation</h3>
                                <p>Streamline operations with dynamic<br/> pricing, risk assessment, and real-<br/>time reporting.</p>
                              </div>
                            </div>

                            <div className="item">
                              <div className="enterpriseSlideDetail">
                                <img className="img-fluid" src="/img/Pricing/analytics_up_2.svg" alt="Advanced Fleet Analytics" />
                                <h3>Advanced Fleet<br/> Analytics</h3>
                                <p>Track vehicle performance, rental<br/> trends, and financial insights to<br/> optimize business decisions.</p>
                              </div>
                            </div>

                            <div className="item">
                              <div className="enterpriseSlideDetail">
                                <img className="img-fluid" src="/img/Pricing/tools_2.svg" alt="Dedicated Developer & Partner Support" />
                                <h3>Dedicated Developer<br/> & Partner Support</h3>
                                <p>Access to documentation,<br/> sandbox environments,<br/> and technical assistance.</p>
                              </div>
                            </div>

                        </Slider> 
      
                    </div>
                  </div>  

                {/* <div className="enterpriseSlideSlider">
                    <div className="carousel-container">
                        <div className="carousel">
                              <div className="carousel-track ">
                                {cards.map((card) => (
                                  <div key={card.id} className="enterpriseSlideDetail">
                                    <img src={card.image} alt={card.heading1} className="img-fluid" />
                                    <h3>{card.heading}</h3>
                                    <p>{card.text}</p>
                                  </div>
                                ))}
                              </div>
                              <div className="carousel-track ">
                                {cards.map((card) => (
                                  <div key={`duplicate-${card.id}`} className="enterpriseSlideDetail">
                                    <img src={card.image} alt={card.heading1} className="img-fluid" />
                                    <h3>{card.heading}</h3>
                                    <p>{card.text}</p>
                                  </div>
                                ))}
                              </div>
                        </div>
                    </div>
                </div> */}
            </section>
            {/* END enterpriseSlideMain */}
        </>
    )
}

export default EnterpriseTabSlide;